import { render, staticRenderFns } from "./StepSix.vue?vue&type=template&id=71bf7e08&scoped=true&"
import script from "./StepSix.vue?vue&type=script&lang=js&"
export * from "./StepSix.vue?vue&type=script&lang=js&"
import style0 from "./StepSix.vue?vue&type=style&index=0&id=71bf7e08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bf7e08",
  null
  
)

export default component.exports